import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Cpu, Database, Sparkles, Zap, Code2 } from 'lucide-react';

const FloatingAIBadges = () => {
  const badges = [
    { icon: Brain, label: 'AI/ML', color: 'from-purple-500 to-pink-500', delay: 0 },
    { icon: Cpu, label: 'Neural Networks', color: 'from-blue-500 to-cyan-500', delay: 0.2 },
    { icon: Database, label: 'Big Data', color: 'from-green-500 to-emerald-500', delay: 0.4 },
    { icon: Sparkles, label: 'Gen AI', color: 'from-yellow-500 to-orange-500', delay: 0.6 },
    { icon: Zap, label: 'Real-time', color: 'from-red-500 to-pink-500', delay: 0.8 },
    { icon: Code2, label: 'Full Stack', color: 'from-indigo-500 to-purple-500', delay: 1.0 },
  ];

  return (
    <div className="fixed right-8 top-1/2 transform -translate-y-1/2 z-30 hidden xl:flex flex-col gap-4 dark:opacity-100 opacity-0 transition-opacity duration-300">
      {badges.map((badge, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ 
            delay: badge.delay, 
            duration: 0.6,
            repeat: Infinity,
            repeatType: "reverse",
            repeatDelay: 3
          }}
          whileHover={{ 
            scale: 1.2, 
            x: -10,
            transition: { duration: 0.2 }
          }}
          className="group relative"
        >
          {/* Glow Effect */}
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.6, 0.3]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: badge.delay
            }}
            className={`absolute inset-0 bg-gradient-to-r ${badge.color} blur-xl opacity-0 group-hover:opacity-50 transition-opacity`}
          />
          
          {/* Badge */}
          <div className={`relative p-3 rounded-xl bg-gradient-to-r ${badge.color} shadow-lg`}>
            <badge.icon className="w-6 h-6 text-white" />
          </div>

          {/* Tooltip */}
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: -10 }}
            className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
          >
            <div className="px-3 py-2 rounded-lg bg-black/90 backdrop-blur-sm border border-white/10 whitespace-nowrap">
              <span className="text-sm text-white font-medium">{badge.label}</span>
            </div>
          </motion.div>

          {/* Animated Pulse */}
          <motion.div
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 0, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: badge.delay
            }}
            className={`absolute inset-0 rounded-xl bg-gradient-to-r ${badge.color} opacity-0`}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingAIBadges;
